module.exports = __webpack_public_path__ + "img/logo.fa18ea0d.png";